import { compose } from "redux";
import { connect } from "react-redux";
import React, { PureComponent } from "react";
import { MenuItem, TextField } from "@material-ui/core";

import { getWorkScheduleDefinitionsFromState } from "features/planner/employee/employee.selectors";

class SelectWorkScheduleDefinition extends PureComponent {
  render() {
    const {
      value,
      filter,
      onChange,
      TextFieldProps,
      workScheduleDefinitions,
    } = this.props;

    return (
      <TextField
        select
        fullWidth
        margin="none"
        value={value}
        onChange={onChange}
        label="Shift Rotation"
        {...TextFieldProps}
      >
        {workScheduleDefinitions.filter(filter).map(workScheduleDefinition => {
          const id = workScheduleDefinition.get("id");
          const name = workScheduleDefinition.get("name");

          return (
            <MenuItem key={id} value={id}>
              {workScheduleDefinition.get("dayCount") > 0
                ? `${name} (${workScheduleDefinition.get("cycle")})`
                : name}
            </MenuItem>
          );
        })}
      </TextField>
    );
  }
}

const defaultFilter = () => true;

SelectWorkScheduleDefinition.defaultProps = {
  filter: defaultFilter,
};

export default compose(
  connect(state => ({
    workScheduleDefinitions: getWorkScheduleDefinitionsFromState(state),
  })),
)(SelectWorkScheduleDefinition);
